// extracted by mini-css-extract-plugin
export var alt = "PageTeaser-module--alt--54cf7";
export var container = "PageTeaser-module--container--f16da";
export var desktopOnly = "PageTeaser-module--desktopOnly--61243";
export var image = "PageTeaser-module--image--5e759";
export var main = "PageTeaser-module--main--95032";
export var mobileOnly = "PageTeaser-module--mobileOnly--8f292";
export var subTitle = "PageTeaser-module--subTitle--2081d";
export var textLeft = "PageTeaser-module--textLeft--cc1a7";
export var title = "PageTeaser-module--title--63c0f";
export var visuallyHidden = "PageTeaser-module--visuallyHidden--6b849";